import { render, staticRenderFns } from "./inTagLite.vue?vue&type=template&id=3615064d&scoped=true"
import script from "./inTagLite.vue?vue&type=script&lang=js"
export * from "./inTagLite.vue?vue&type=script&lang=js"
import style0 from "./inTagLite.vue?vue&type=style&index=0&id=3615064d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615064d",
  null
  
)

export default component.exports